// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__2lmSx","tablet":"styles_tablet__2ybZM","desktop":"styles_desktop__1_lC9","ResizedImg":"styles_ResizedImg__4gbhy"};